import React from "react";
import { useState, useEffect } from "react";
import { FiUpload } from "react-icons/fi";
import { AssetEditImageApi } from "../../../services/AssetService";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import FileUpload from "../../Constant/fileupload";
const AssetEditImage = ({ visible, onClose, id, onAfterSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    file: "",
  });
  useEffect(() => {
    handleReset();
  }, [visible]);

  const handleReset = () => {
    setForm({
      file: "",
    });
  };

  const handleConfirm = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("image", form.file);
    AssetEditImageApi(id,formData)
      .then((res) => {
        toast.success("Update Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        console.log(err)
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Edit Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-2">
            <div className="col-12 mb-5">
              <label className="form-label text-dark mb-2">Upload Image</label>
              <FileUpload
                label="Drag & drop File (max size 3MB)"
                accept=".jpg,.jpeg,.png"
                multiple={false}
                value={form.file}
                onChange={(files) =>
                  setForm((prev) => ({ ...prev, file: files }))
                }
              />
            </div>

            <div className="col-12 mt-1">
              <code className="text-light">
                <strong>Note:</strong> Upload a valid image for the asset.
                Accepted formats: JPG, PNG. Max size: 3MB.
              </code>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-danger"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={loading || !form.file}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AssetEditImage;
